<template>
    <span class="p-2 mt-3 mr-3 duration-300 bg-black rounded-md text-slate-200 hover:bg-blue-600 hover:cursor-default">{{text}}</span>
</template>


<script>
export default {
    props: ['text'],
    name: 'SkillItem'    
}
</script>


<style>
    
</style>